import React from 'react';
import './SandboxBanner.scss';
import { useSandbox } from '../../../hooks/useSandbox';
import { useAppSelector } from '../../../state';
import { selectJobType } from '../../../state/slices/slice-link-api';
function SandboxBannerLinkApi() {
    var hint = useSandbox().hint;
    var isLoginJobType = useAppSelector(selectJobType) === 'login';
    return isLoginJobType && hint ? (React.createElement("div", { className: "sandbox-banner" }, hint)) : null;
}
export default SandboxBannerLinkApi;
